import classNames from 'classnames';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ProgressIndicator } from '@bingads-webui-react/fabric-control';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { StepsContext } from './index';
import { getStyles } from './styles';
import { getLocalizedStepTitle } from '../util/get-localized-step-title';

export function StepProgressIndicator(props) {
  const {
    showStepNumber,
  } = props;
  const { steps } = useContext(StepsContext);
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);

  if (!steps) return null;

  const currentStepIndex = Math.max(
    0,
    steps.findIndex(step => step.isSelected || step.containsSelected)
  );

  return (
    <ProgressIndicator
      className={classNames('step-progress-indicator', classes.progressIndicator)}
      label={
        showStepNumber
          ? getLocalizedStepTitle(i18n, steps[currentStepIndex].title, currentStepIndex + 1)
          : steps[currentStepIndex].title
      }
      percentComplete={(currentStepIndex + 1) / steps.length}
    />
  );
}

StepProgressIndicator.propTypes = {
  showStepNumber: PropTypes.bool,
};

StepProgressIndicator.defaultProps = {
  showStepNumber: false,
};
